"use client";

import { useStore } from "@/store";

export function useMediaAuth() {
  const user = useStore.use.user();
  const authStatus = useStore.use.authStatus();
  const error = useStore.use.error();

  const checkSession = useStore.use.checkSession();
  const logout = useStore.use.logout();

  return {
    user,
    authStatus,
    error,
    checkSession,
    logout,
    isAuthed: authStatus === "authed",
    isChecking: authStatus === "checking",
    isUnauth: authStatus === "unauth",
  };
}
